module.exports = __webpack_public_path__ + "static/img/6.5ae8aa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/cooperate/6.png
// module id = 1M/H
// module chunks = 1